<template>
  <v-card :class="['tools-panel', { 'tools-panel--page': !sheet }]" tile>
    <header class="tools-panel__header">
      <div class="tools-panel__heading">
        <span class="tools-panel__icon"><v-icon>mdi-tune-variant</v-icon></span>
        <div>
          <small>Administration</small>
          <h2>Tools & settings</h2>
          <p>Manage your team, workplace, and application.</p>
        </div>
      </div>
      <v-btn v-if="sheet" class="tools-panel__close" icon @click="$emit('close')" aria-label="Close tools">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </header>

    <div class="tools-panel__body">
      <div class="tool-grid">
        <button type="button" class="tool-card" @click="navigate('employee-list')">
          <span class="tool-card__icon tool-card__icon--employees"><v-icon>mdi-account-group-outline</v-icon></span>
          <span><strong>Employees</strong><small>Profiles, access, PINs, and pay</small></span>
          <v-icon class="tool-card__arrow">mdi-chevron-right</v-icon>
        </button>

        <button type="button" class="tool-card" @click="navigate('department-list')">
          <span class="tool-card__icon tool-card__icon--departments"><v-icon>mdi-office-building-outline</v-icon></span>
          <span><strong>Departments</strong><small>Organize employees into teams</small></span>
          <v-icon class="tool-card__arrow">mdi-chevron-right</v-icon>
        </button>

        <button v-if="employeeAccess.setting && employeeAccess.setting.edit" type="button"
          class="tool-card" @click="navigate('general-setting')">
          <span class="tool-card__icon tool-card__icon--settings"><v-icon>mdi-cog-outline</v-icon></span>
          <span><strong>General settings</strong><small>Time clock and workplace options</small></span>
          <v-icon class="tool-card__arrow">mdi-chevron-right</v-icon>
        </button>

        <button type="button" class="tool-card" @click="downloadSupport">
          <span class="tool-card__icon tool-card__icon--support"><v-icon>mdi-lifebuoy</v-icon></span>
          <span><strong>Remote support</strong><small>Download the support application</small></span>
          <v-icon class="tool-card__arrow">mdi-download-outline</v-icon>
        </button>
      </div>

      <div class="device-info">
        <div class="device-info__heading">
          <span><v-icon small>mdi-map-marker-outline</v-icon>Current workplace</span>
          <small>App version {{ version }}</small>
        </div>
        <div v-if="Location" class="location-code">
          <div>
            <small>{{ Location.name || "Location" }}</small>
            <strong id="locationCode">{{ Location.code }}</strong>
          </div>
          <v-btn class="copy-code" text small @click="copyCode">
            <v-icon left small>mdi-content-copy</v-icon>Copy code
          </v-btn>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
const pjson = require("../../../package.json");

export default {
  props: {
    sheet: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Location: null,
    items: [
      // { text: "Time Clock", icon: "mdi-clock", route: "/clockInOut" },

      { text: "Employee", icon: "mdi-account", route: "employee" },
      // { text: "Reports", icon: "mdi-flag" },
      { text: "Setting", icon: "mdi-cog", route: "general" },
      // { text: "Switch Location", icon: "mdi-shield-key", route: "/location" },
      // { text: "Logout", icon: "mdi-logout", route: "/logout" },
    ],
  }),
  methods: {
    navigate(name) {
      this.$emit("close");
      this.$router.push({ name });
    },
    downloadSupport() {
      this.$emit("close");
      window.open(
        "https://play.google.com/store/apps/details?id=com.splashtop.sos&hl=en_US&gl=US"
      );
    },
    copyCode() {
      var copyText = document.getElementById("locationCode");
      console.log("copyText", copyText.innerHTML);

      navigator.clipboard.writeText(copyText.innerHTML);
      this.$toast.success("Location code was copy", { timeout: 2000 });
    },
  },
  created() {
    console.log('employeeAccess', this.employeeAccess)
    this.Location = JSON.parse(
      localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
    );
  },
  computed: {
    ...mapGetters("employee", ["employeeAccess"]),
    version() {
      // console.log('pjson', pjson.version)
      return pjson.version;
    },
    generateTimeClockToken() {
      let rand = function () {
        return Math.random().toString(36).substr(2);
      };

      return rand() + rand();
    },
  },
};
</script>

<style scoped>
.tools-panel {
  background: var(--v-surface-base) !important;
  color: var(--v-textPrimary-base);
  overflow: hidden;
}

.tools-panel--page {
  border-radius: 20px !important;
  margin: 24px auto;
  max-width: 760px;
}

.tools-panel__header {
  align-items: flex-start;
  border-bottom: 1px solid var(--v-border-base);
  display: flex;
  padding: 22px 24px 18px;
}

.tools-panel__heading {
  align-items: center;
  display: flex;
  gap: 14px;
  min-width: 0;
}

.tools-panel__icon {
  align-items: center;
  background: rgba(34, 211, 238, 0.11);
  border: 1px solid rgba(34, 211, 238, 0.22);
  border-radius: 14px;
  display: flex;
  flex: 0 0 48px;
  height: 48px;
  justify-content: center;
}

.tools-panel__icon .v-icon {
  color: var(--v-accent-base);
}

.tools-panel__heading small {
  color: var(--v-textSecondary-base);
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.tools-panel__heading h2 {
  font-size: 1.3rem;
  line-height: 1.25;
  margin: 1px 0 2px;
}

.tools-panel__heading p {
  color: var(--v-textSecondary-base);
  font-size: 0.75rem;
  margin: 0;
}

.tools-panel__close {
  background: var(--v-surfaceMuted-base);
  color: var(--v-textPrimary-base);
  margin-left: auto;
}

.tools-panel__body {
  max-height: min(68vh, 650px);
  overflow: auto;
  padding: 18px 20px 24px;
}

.tool-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.tool-card {
  align-items: center;
  background: var(--v-surfaceMuted-base);
  border: 1px solid var(--v-border-base);
  border-radius: 14px;
  color: var(--v-textPrimary-base);
  cursor: pointer;
  display: flex;
  font: inherit;
  gap: 12px;
  min-height: 76px;
  padding: 12px;
  text-align: left;
  transition: border-color 0.2s, transform 0.2s;
}

.tool-card:hover {
  border-color: var(--v-primary-base);
  transform: translateY(-1px);
}

.tool-card > span:nth-child(2) {
  min-width: 0;
}

.tool-card strong,
.tool-card small {
  display: block;
}

.tool-card strong {
  font-size: 0.85rem;
}

.tool-card small {
  color: var(--v-textSecondary-base);
  font-size: 0.67rem;
  line-height: 1.35;
  margin-top: 3px;
}

.tool-card__icon {
  align-items: center;
  border-radius: 11px;
  display: flex;
  flex: 0 0 40px;
  height: 40px;
  justify-content: center;
}

.tool-card__icon--employees {
  background: rgba(52, 211, 153, 0.12);
}

.tool-card__icon--employees .v-icon {
  color: var(--v-success-base);
}

.tool-card__icon--departments {
  background: rgba(96, 165, 250, 0.12);
}

.tool-card__icon--departments .v-icon {
  color: var(--v-primary-base);
}

.tool-card__icon--settings {
  background: rgba(251, 191, 36, 0.12);
}

.tool-card__icon--settings .v-icon {
  color: var(--v-warning-base);
}

.tool-card__icon--support {
  background: rgba(34, 211, 238, 0.12);
}

.tool-card__icon--support .v-icon {
  color: var(--v-accent-base);
}

.tool-card__arrow {
  color: var(--v-textSecondary-base);
  margin-left: auto;
}

.device-info {
  background: var(--v-surfaceMuted-base);
  border: 1px solid var(--v-border-base);
  border-radius: 14px;
  margin-top: 14px;
  padding: 13px;
}

.device-info__heading,
.device-info__heading span,
.location-code {
  align-items: center;
  display: flex;
}

.device-info__heading {
  color: var(--v-textSecondary-base);
  font-size: 0.68rem;
  justify-content: space-between;
}

.device-info__heading span {
  font-weight: 700;
  gap: 5px;
}

.device-info__heading .v-icon {
  color: var(--v-primary-base);
}

.location-code {
  border-top: 1px solid var(--v-border-base);
  justify-content: space-between;
  margin-top: 10px;
  padding-top: 10px;
}

.location-code small,
.location-code strong {
  display: block;
}

.location-code small {
  color: var(--v-textSecondary-base);
  font-size: 0.68rem;
}

.location-code strong {
  font-size: 0.82rem;
  margin-top: 2px;
}

.copy-code {
  color: var(--v-primary-base) !important;
  font-weight: 700;
  text-transform: none;
}

@media (max-width: 600px) {
  .tools-panel__header {
    padding: 18px 16px 14px;
  }

  .tools-panel__icon {
    flex-basis: 42px;
    height: 42px;
  }

  .tools-panel__heading h2 {
    font-size: 1.1rem;
  }

  .tools-panel__heading p {
    display: none;
  }

  .tools-panel__body {
    max-height: 72vh;
    padding: 12px 12px 20px;
  }

  .tool-grid {
    grid-template-columns: 1fr;
  }
}
</style>
